export enum TZ {
    HN = 'America/Tegucigalpa',
    IE = 'Europe/Dublin',
  }